module.exports = __webpack_public_path__ + "static/media/Molecule.c451ec97.svg";